import React, {useState } from "react";
import { useStepNavigate } from "../hooks/useStepNavigate";
import { useOrder } from "../context/OrderContext";
import TablerLayout from "../components/layout/TablerLayout";
import StepperNavButton from "../components/stepper/StepperNavButton";
import Modal from "../components/modals/Modal";
import { IconQuestionMark} from "@tabler/icons-react";
import { showErrorToast} from "../components/toasts/ToastService";
import { useOrderSave } from "../context/OrderSaveContext";

const OsszesitoTablazat = () => {
    const { order, updateOrder } = useOrder();
    const { saveOrder } = useOrderSave();
    const navigate = useStepNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editVenyIdx, setEditVenyIdx] = useState(null);
    const [deleteVenyIdx, setDeleteVenyIdx] = useState(null);
    // const [setShowResetModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    const handleAnswerNo = () => {
        setIsModalOpen(false);
        navigate("/VenyekLista");
    };



    const handleAnswerYes = async () => {
		try {
            setIsModalOpen(false);
            setIsLoading(true);

			const updatedOrder = order;
			updateOrder(updatedOrder);
			const result = await saveOrder(updatedOrder);

			if (result?.success !== false) {
				navigate("/TeritesiDij");
			} else {
				showErrorToast(result?.message || "Hiba történt a rendelés mentése során!");
			}
		} catch (error) {
			console.error("Hiba történt a vény típusának kiválasztásakor:", error);
            showErrorToast("Hiba történt a mentés során!");
		} finally {
            setIsLoading(false);
        }
	};


    const handleBackClick = () => {
        navigate("/VenyekLista");
    };

    const handleEditVeny = (idx) => {
        updateOrder({
            ...order,
            aktivVenyIndex: idx,
        });
        navigate("/TartozekValaszto");
        setEditVenyIdx(null);
    };

    const handleDeleteVeny = (idx) => {
        const venyek = order.venyek.filter((_, i) => i !== idx);
        let newIndex = order.aktivVenyIndex;
        if (newIndex >= venyek.length) newIndex = venyek.length - 1;
        updateOrder({
            ...order,
            venyek,
            aktivVenyIndex: Math.max(0, newIndex),
        });
        setDeleteVenyIdx(null);
    };

    // const confirmReset = () => {
    //     setShowResetModal(true);
    // };

    return (
        <TablerLayout title="Összesítő táblázat - Választott tartozékok">
            <div className="row justify-content-center">
                <div className="col-md-10 mb-4">
                    <div className="card-body">
                        {order.venyek.map((veny, idx) => (
                            <div key={idx} className="mb-4">
                                {/* Desktop nézet (md-nél nagyobb) */}
                                <div className="d-none d-md-flex justify-content-between align-items-center mb-2">
                                    <h5 className="fs-4 mb-0">
                                        Vény #{idx + 1}
                                        {veny.veny_receipt && <span className="ms-2 fs-5 text-muted">({veny.veny_receipt})</span>}
                                    </h5>
                                    <div className="d-flex gap-2">
                                        <button className="btn btn-sm btn-primary" onClick={() => setEditVenyIdx(idx)} disabled={isLoading}>
                                            Tartozékok módosítás
                                        </button>
                                        <button 
                                            className="btn btn-sm btn-danger" 
                                            onClick={() => setDeleteVenyIdx(idx)} 
                                            disabled={order.venyek.length === 1 || isLoading || veny.veny_shoes_med_left || veny.veny_shoes_med_right} 
                                            title={
                                                order.venyek.length === 1 
                                                    ? "Legalább egy vénynek maradnia kell!" 
                                                    : (veny.veny_shoes_med_left || veny.veny_shoes_med_right)
                                                        ? "Cipő orvosi kóddal rendelkező vényt nem lehet törölni!"
                                                        : ""
                                            }
                                        >
                                            Törlés
                                        </button>
                                    </div>
                                </div>

                                {/* Mobil nézet (md-nél kisebb) */}
                                <div className="d-md-none mb-3">
                                    <h5 className="fs-4 mb-2 text-center">
                                        Vény #{idx + 1}
                                        {veny.veny_receipt && <span className="ms-2 fs-5 text-muted">({veny.veny_receipt})</span>}
                                    </h5>
                                    <div className="d-flex gap-2">
                                        <button className="btn btn-sm btn-primary flex-fill" onClick={() => setEditVenyIdx(idx)} disabled={isLoading}>
                                            Tartozékok módosítás
                                        </button>
                                        <button 
                                            className="btn btn-sm btn-danger flex-fill" 
                                            onClick={() => setDeleteVenyIdx(idx)} 
                                            disabled={order.venyek.length === 1 || isLoading || veny.veny_shoes_med_left || veny.veny_shoes_med_right} 
                                            title={
                                                order.venyek.length === 1 
                                                    ? "Legalább egy vénynek maradnia kell!" 
                                                    : (veny.veny_shoes_med_left || veny.veny_shoes_med_right)
                                                        ? "Cipő orvosi kóddal rendelkező vényt nem lehet törölni!"
                                                        : ""
                                            }
                                        >
                                            Törlés
                                        </button>
                                    </div>
                                </div>

                                <table className="table table-bordered align-middle">
                                    <thead className="table-light">
                                        <tr>
                                            <th className="text-center" style={{ width: "80%" }}>Tartozék</th>
                                            <th className="text-center" style={{ width: "20%" }}>Választott láb</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {/* Cipő orvosi kódok megjelenítése */}
                                        {(veny.veny_shoes_med_left || veny.veny_shoes_med_right) && (
                                            <>
                                                {veny.veny_shoes_med_left && (
                                                    <tr className="table-info">
                                                        <td><strong>Cipő orvosi kód: {veny.veny_shoes_med_left}</strong></td>
                                                        <td className="text-start">Bal láb</td>
                                                    </tr>
                                                )}
                                                {veny.veny_shoes_med_right && (
                                                    <tr className="table-info">
                                                        <td><strong>Cipő orvosi kód: {veny.veny_shoes_med_right}</strong></td>
                                                        <td className="text-end">Jobb láb</td>
                                                    </tr>
                                                )}
                                            </>
                                        )}
                                        
                                        {/* Tartozékok listázása */}
                                        {veny.components && veny.components.length > 0 ? (
                                            veny.components.map((component, i) => (
                                                <tr key={i} >
                                                    <td className="bg-gray-100">{component.aidfinance_national}</td>
                                                    <td className={component.is_left === 1 ? "text-start bg-gray-100" : "text-end bg-gray-100"} >
                                                        {component.is_left === 1 ? "Bal láb" : "Jobb láb"}
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={2} className="text-center text-muted bg-gray-200">
                                                    Nincs kiválasztott tartozék.
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="d-flex justify-content-between mt-4">
                    <StepperNavButton side="left" label="Vissza" disabled={isLoading} onClick={handleBackClick} />
                    <StepperNavButton side="right" label={isLoading ? "Mentés..." : "Tovább"} disabled={isLoading} onClick={handleOpenModal} />
                </div>
            </div>
            
            {/* Eredeti modális ablakok */}
            <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onConfirm={handleAnswerYes} onSecondary={handleAnswerNo} title="Megerősítés" type="warning" confirmText="Igen" secondaryText="Nem" confirmClass="btn btn-primary" secondaryClass="btn btn-danger" showSecondary={true} showCancel={false} icon={<IconQuestionMark size={70} stroke={2} className="text-warning" />}>
                <h4>Minden tartozék és vény szerepel?</h4>
            </Modal>
            
            <Modal isOpen={editVenyIdx !== null} onClose={() => setEditVenyIdx(null)} onConfirm={() => handleEditVeny(editVenyIdx)} title="Vény módosítása" type="warning" confirmText="Igen" secondaryText="Mégsem" confirmClass="btn btn-primary" secondaryClass="btn btn-secondary" showSecondary={true} showCancel={true} icon={<IconQuestionMark size={70} stroke={2} className="text-warning" />}>
                <h4>Biztosan módosítani szeretné a vényen található tartozékokat?</h4>
            </Modal>
            
            <Modal isOpen={deleteVenyIdx !== null} onClose={() => setDeleteVenyIdx(null)} onConfirm={() => handleDeleteVeny(deleteVenyIdx)} title="Vény törlése" type="danger" confirmText="Igen" secondaryText="Mégsem" confirmClass="btn btn-danger" secondaryClass="btn btn-secondary" showSecondary={true} showCancel={true} icon={<IconQuestionMark size={70} stroke={2} className="text-danger" />}>
                <h4>Biztosan törölni szeretné ezt a vényt?</h4>
            </Modal>
        </TablerLayout>
    );
};

export default OsszesitoTablazat;
